import script from "./PrivacyDisclaimerAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyDisclaimerAbout.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyDisclaimerAbout.vue?vue&type=style&index=0&id=78c45b1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c45b1b"]])

export default __exports__